import "./OportunidadesDeTrabajoBox.scss";
import { Button } from "../Button/Button";
import ReactMarkdown from "react-markdown";

const OportunidadesDeTrabajoBox = ({
	img,
	boldText,
	text,
	buttonRoute,
	buttonText,
}) => {
	return (
		<div className="oportunidadesDeTrabajoBox--container">
			<div className="oportunidadesDeTrabajoBox--img-container">
				<img
					src={img}
					alt="Carrera"
					className="oportunidadesDeTrabajoBox--img all-width-height aspect-ratio cover"
				/>
			</div>
			<div className="oportunidadesDeTrabajoBox--text-container oportunidadesDeTrabajoBox--elements-position">
				<h4 className="t4">{boldText}</h4>
				<div className="oportunidadesDeTrabajoBox--markdown-container">
					<ReactMarkdown>{text}</ReactMarkdown>
				</div>
			</div>
			<div className="oportunidadesDeTrabajoBox--button-container oportunidadesDeTrabajoBox--elements-position">
				<Button
					type="button light-blue"
					buttonRoute={buttonRoute}
					content={buttonText}
				/>
			</div>
		</div>
	);
};

export default OportunidadesDeTrabajoBox;
